import React from 'react'
import styled from 'styled-components'

const ShopbyActivity = () => {
  return (
    <Wrapper>
        <div className='container py-2'>
            <div className='container d-flex align-items-center justify-content-center' style={{backgroundColor:'#000',}}>
                <h2 className='text-light display-4 display-lg-3 fw-bold py-3 py-lg-4 py-xlg-5'>SHOP BY ACTIVITY</h2>
            </div>
            <div className='container py-3'>
                <div className='row '>
                    <div className='col-6 col-md-3 p-1 runingandwalking'>
                        <img className='img-fluid w-100' src='/images/ACTIVITY.jpg'/>
                    </div>
                    <div className='col-6 col-md-3 p-1 training'>
                        <img className='img-fluid' src='/images/ACTIVITY.jpg'/>
                    </div>
                    <div className='col-6 col-md-3 p-1 sports'>
                        <img className='img-fluid' src='/images/ACTIVITY.jpg'/>
                    </div>
                    <div className='col-6 col-md-3 p-1 athleisure'>
                        <img className='img-fluid' src='/images/ACTIVITY.jpg'/>
                    </div>
                </div>
            </div>
        </div>
      </Wrapper> 
  )
}

export default ShopbyActivity


const Wrapper = styled.section`
    @media(max-width:576px){
        h2{
            font-size:1.3rem;
            margin-bottom: 0;
        }
    }
`;


// const Wrapper = styled.section`
// .runingandwalking{
//     // background-color:rgba(135, 149, 150, 0.024);
//     background: url("/puma/runingandwalking.jpg") no-repeat center center / cover,
//             rgba(62, 125, 129, 0.02);
//     background-blend-mode: overlay; /* makes rgba layer visible on top */
//     height:300px;
// }
// .runingandwalking:hover{
//     background:url("/puma/runingandwalking.jpg") no-repeat center center / cover,rgba(21, 22, 22, 0.02);
// }

// .training{
//     // background-color:rgba(135, 149, 150, 0.024);
//     background: url("/puma/training.jpg") no-repeat center center / cover,
//             rgba(62, 125, 129, 0.02);
//     background-blend-mode: overlay; /* makes rgba layer visible on top */
//     height:300px;
// }
// .training:hover{
//     background:url("/puma/training.jpg") no-repeat center center / cover,rgba(21, 22, 22, 0.02);
// }

// .sports{
//     // background-color:rgba(135, 149, 150, 0.024);
//     background: url("/puma/sports.jpg") no-repeat center center / cover,
//             rgba(62, 125, 129, 0.02);
//     background-blend-mode: overlay; /* makes rgba layer visible on top */
//     height:300px;
// }
// .sports:hover{
//     background:url("/puma/sports.jpg") no-repeat center center / cover,rgba(21, 22, 22, 0.02);
// }

// .athleisure{
//     // background-color:rgba(135, 149, 150, 0.024);
//     background: url("/puma/athleisure.jpg") no-repeat center center / cover,
//             rgba(62, 125, 129, 0.02);
//     background-blend-mode: overlay; /* makes rgba layer visible on top */
//     height:300px;
// }
// .athleisure:hover{
//     background:url("/puma/athleisure.jpg") no-repeat center center / cover,rgba(21, 22, 22, 0.02);
// }

// @media(max-width:720px){
//     .athleisure{
//         height:300px !important;
//     }
// }
// `;